import { Button, Modal, Row, Table } from 'antd';

import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { useCapturePostHog } from '../../../../hooks/useCapturePostHog';
import type { SortedInfo } from '../../../../models/table';
import { GetCheckInsModalProps } from './check-ins-modal-props';
import type { CheckIn, DashboardModalType } from './modalDashboardSlice';
import { clearModalFilter, closeDashboardModal, DASHBOARD_MODAL, handleModalTableChange } from './modalDashboardSlice';

export const CheckInsModal = ({ data, filtersInfo }: { data: CheckIn[] | null; filtersInfo: string }) => {
  const dispatch = useAppDispatch();
  const { capturePostHogCustomEvent } = useCapturePostHog();
  const open = useAppSelector((state) => state.modalDashboardSlice.modal === DASHBOARD_MODAL.CHECK_INS);
  const { columns, clearSearch } = GetCheckInsModalProps();

  return (
    <Modal
      className="dashboardModal"
      width={'40%'}
      title="Total check-ins details"
      open={open}
      onCancel={() => {
        capturePostHogCustomEvent('CheckInsModal close modal');
        dispatch(closeDashboardModal());
      }}
      mask={{ blur: false, closable: false }}
      footer={null}
    >
      <Row className="filtersInfoRow" justify="space-between" align="middle">
        <p style={{ marginTop: 'auto', marginBottom: 'auto' }}>{filtersInfo}</p>
        <Button
          onClick={() => {
            dispatch(clearModalFilter());
            clearSearch();
            dispatch(
              handleModalTableChange({
                sorter: {
                  columnKey: 'total',
                  field: 'total',
                  order: 'descend',
                },
              }),
            );
            capturePostHogCustomEvent('CheckInsModal clear filters');
          }}
        >
          Clear filters
        </Button>
      </Row>
      <Table
        className="dashboardTable"
        columns={columns}
        rowKey="client_id"
        onChange={(pagination, filters, sorter) => {
          dispatch(handleModalTableChange({ pagination, filters, sorter: sorter as SortedInfo<DashboardModalType> }));
          capturePostHogCustomEvent('CheckInsModal handle table change');
        }}
        pagination={
          data && data.length > 20
            ? {
                showTotal: (total, range) => {
                  return `Showing ${range[0]}-${range[1]} of ${total} results`;
                },
                placement: ['bottomEnd'],
                defaultPageSize: 20,
              }
            : false
        }
        dataSource={data || undefined}
        scroll={{ y: 'calc(100vh - 400px)' }}
      />
    </Modal>
  );
};
